<template></template>

<script>
export default {
    name: "IntegrationFacebookCallback",
    data() {
        return {};
    },
    mounted() {
        this.sendMessage();
    },
    methods: {
        sendMessage() {
            const getUrlParameter = (e, uri) => {
                e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var t = new RegExp("[\\?&]" + e + "=([^&#]*)").exec(uri);
                return null === t
                    ? null
                    : decodeURIComponent(t[1].replace(/\+/g, " "));
            };

            window.opener.postMessage(
                { code: getUrlParameter("code", window.location.href) },
                window.location.origin
            );
        },
    },
};
</script>

<style></style>
